export default __webpack_public_path__ + "static/media/noirnoir-divineswelling-00.00c4a107.jpg";